const snackDuration = 1 * 1000;
export const authCheckDuration = 3 * 1000;
export const maxAuthCheck = 5;

export const snackDetails = {
  duration: snackDuration,
  open: false,
  severity: "success",
  message: "Successfull",
};

export const getOpenSnakSuccessData = (
  message = "Successfull!!!",
  duration = snackDuration
) => {
  return {
    duration: duration,
    open: true,
    severity: "success",
    message: message,
  };
};

export const getCloseSnakData = (prev) => {
  return {
    duration: snackDuration,
    open: false,
    severity: prev?.severity || "success",
    message: "",
  };
};

export const getOpenSnakErrorData = (
  message = "Error!!!",
  duration = snackDuration
) => {
  return {
    duration: duration,
    open: true,
    severity: "error",
    message: message,
  };
};

// setSnack;
